export default class CoordinateSequenceFilter {
  filter(seq, i) {}
  isDone() {}
  isGeometryChanged() {}
}
